<template>
    <el-tooltip
        class="item"
        effect="dark"
        placement="right"
    >
        <div slot="content">Available: {{asset.fund_available}}<br/>Loacked: {{asset.fund_lock}}<br/><br/>{{hint}}</div>
        <div class="balance" v-if="asset" :data-selected="selected" @click="onClick">
            <div class="asset_name">{{asset.asset_name}}</div>
            <div class="asset_balance">
                <div class="asset_balance_available">{{asset.fund_available}}</div>
                <div class="asset_balance_lock">
                    <i class="el-icon-lock"></i>
                    {{asset.fund_lock}}
                </div>
            </div>
            <div class="arrow-left" v-if="selected"></div>
        </div>
    </el-tooltip>
</template>

<script>
// import { mapActions } from "vuex";

export default {
    name: "Balance",
    props: {
        selected_asset_name: { default: null },
        asset: Object,
        onSelect: Function
    },
    data() {
        return {};
    },
    computed: {
        selected() {
            return this.selected_asset_name == this.asset.asset_name;
        },
        hint() {
            return `Click to view ${this.asset.asset_name} account transaction history`
        }
    },
    methods: {
        onClick() {
            if (!this.selected) {
                this.onSelect(this.asset.asset_name);
            } else {
                this.onSelect(null);
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.balance {
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    display: flex;
    cursor: pointer;
    position: relative;
}

.balance:hover {
    outline: none;
    background-color: rgba(0, 0, 0, 0.2);
}

.balance:active {
    outline: none;
}

.balance[data-selected="true"], .balance[data-selected="true"]:hover {
    background-color: #00517b;
}

.asset_name {
    line-height: 80px;
    padding: 0 20px;
    width: 140px;
    border-right: 1px solid rgba(255, 255, 255, 0.2);
    font-size: 1.2em;
    background-color: rgba(0, 0, 0, 0.3);
}

.asset_balance {
    display: flex;
    flex-direction: column;
    line-height: 40px;
    flex: 1;
}

.asset_balance_available {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.asset_balance > div {
    padding: 0 10px;
}

.asset_balance_lock {
    color: #eee;
}

.arrow-left {
    width: 0px;
    height: 0px;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    border-right: 20px solid rgba(0, 0, 0, 0.7);
    position: absolute;
    right: -1px;
    top: 20px;
}
</style>
